import { useState } from 'react';

const useModal = () => {
    const [isShown, setIsShown] = useState<boolean>(false);
    const toggle = () => setIsShown(!isShown);
    const close = () => setIsShown(false);
    const open = () => setIsShown(true);

    return {
        isShown,
        toggle,
        close,
        open
    };
};

export default useModal;